<template>
  <div class="handle-batch">
    <div class="main">
      <mk-checkbox
        v-if="isCheckAll"
        v-model="checked"
        class="check-all"
        label="全选该页"
        @change="change"
      />
      <div
        v-for="(item,index) in config"
        :key="index"
        class="edit"
        @click="edit(item.event)"
      >
        <ds-iconfont
          :icon-class="item.icon"
          class="icon"
        />
        <span class="txt">{{ item.name }}</span>
      </div>
    </div>
    <div class="cancel">
      <div class="total">
        共选择
        <span class="num">{{ selectNum }}</span>
        项
      </div>
      <div
        class="cancel-btn"
        @click="cancel"
      >
        取消
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HandleBatch',
  props: {
    // 是否需要全选
    isCheckAll: {
      type: Boolean,
      default: true
    },
    // 操作按钮配置
    config: {
      type: Array,
      default () {
        return []
      }
    },
    // 被选中条数
    selectNum: {
      type: Number,
      default: 0
    },
    // 每页条数
    pageSize: {
      type: Number,
      default: 10
    },
    // 总条数
    total: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      checked: false
    }
  },
  watch: {
    selectNum () {
      if (this.total < this.pageSize) {
        this.checked = this.selectNum === this.total
      } else {
        this.checked = this.selectNum === this.pageSize
      }
    }
  },
  methods: {
    // 全选/全不选
    change () {
      this.$emit('select-all', this.checked)
    },
    // 编辑
    edit (eventName) {
      this.$emit(eventName)
    },
    // 取消
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>
<style lang="scss" scoped>
  .handle-batch {
    width: 100%;
    height: 52px;
    box-shadow: 0 -1px 4px 0 rgba(0, 0, 0, 0.15);
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    z-index: 9;
    background: #fff;

    .main,
    .cancel {
      height: 16px;
      display: flex;
      align-items: center;
    }

    .check-all {
      margin-left: 30px;
    }

    /deep/ .el-checkbox__label {
      line-height: 16px;
    }

    .remove,
    .edit,
    .delete {
      height: 16px;
      margin-left: 24px;
      display: flex;
      align-items: center;

      .icon {
        color: #595959;
      }

      .txt {
        font-size: 13px;
        color: #595959;
        margin: 2px 0 0 4px;
      }

      &:hover {
        cursor: pointer;

        .icon,
        .txt {
          color: #009cff;
        }
      }
    }

    .delete {
      margin-left: 28px;
    }

    .total {
      color: #262626;
      font-size: 13px;

      .num {
        color: #009cff;
      }
    }

    .cancel-btn {
      font-size: 13px;
      color: #009cff;
      margin: 0 20px 0 16px;
      cursor: pointer;
    }
  }
</style>
